import { Wallet } from 'lucide-react';
import InsuranceCard from 'components/Appointment/ConfirmAppointmentModal/InsuranceCard';
import { formatDate } from 'utils/helpers';

const InsuranceReview = ({ data, memberName }) => {
  const isActive = Boolean(data?.active);
  const cardPics = [
    { label: 'Front', url: data?.card_front_pic },
    { label: 'Back', url: data?.card_back_pic },
  ].filter(({ url }) => url);

  if (!isActive) {
    return (
      <div className="flex flex-col items-center gap-3 rounded-2xl border border-gray-200 bg-gray-50 px-6 py-10 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
          <Wallet size={22} className="text-secondary-400" />
        </div>
        <div>
          <p className="text-base font-bold text-secondary-900">You're marked as self-pay</p>
          <p className="mt-1 text-sm text-secondary-500">
            No dental insurance is on file — you'll be billed directly for this visit.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-3">
        <p className="text-[11px] font-bold uppercase tracking-wider text-secondary-400">Insurance on file</p>
        <div className="flex items-center gap-2">
          {data?.updated_at && (
            <span className="text-xs text-secondary-400">Updated {formatDate(data.updated_at, 'medium')}</span>
          )}
          <span className="rounded-md bg-green-50 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-green-700">
            Active
          </span>
        </div>
      </div>

      <InsuranceCard data={data} memberName={memberName} />

      {cardPics.length > 0 && (
        <div className="flex items-start gap-3 pt-1">
          {cardPics.map(({ label, url }) => (
            <a
              key={label}
              href={url}
              target="_blank"
              rel="noreferrer"
              className="min-w-0 flex-1"
              title={`View ${label.toLowerCase()} of card`}
            >
              <p className="text-[10px] font-bold uppercase tracking-wider text-secondary-400">{label} of card</p>
              <img
                src={url}
                alt={`${label} of insurance card`}
                className="mt-1 h-24 w-full rounded-lg border border-gray-200 bg-gray-50 object-contain p-1 transition-opacity hover:opacity-90"
              />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default InsuranceReview;
